module.exports = __webpack_public_path__ + "img/postales.39b50ee0.gif";